module.exports = __webpack_public_path__ + "img/0Q3A6453_L.42d35c52.webp";